import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {CollectionWorkProjectType, ICollectionWork} from './useCollectionWork';
import {CollectionWorkProjectStatusConfig} from './useCollectionWorkProjectRecord';

export interface ICollectionWorkProject {
  id: number;
  name: string;
  type: CollectionWorkProjectType;
  fileSizeMb: number;
  collectionWorkId: number;
  collectionWork?: ICollectionWork;
  remark: string;
  maxScore: number;
}

export interface ICollectionWorkProjectSaveParams {
  collectionWorkId?: number;
  id?: number;
  name: string;
  type: CollectionWorkProjectType;
  fileSizeMb: number;
  remark: string;
  maxScore: number;
}

export interface ICollectionWorkProjectListParams {
  collectionWorkId?: number;
}

export interface ICollectionWorkProjectListScoreParams {
  projectId?: number;
  studentId?: number;
  reviewerId?: number;
  wordId?: number;
}

export interface ICollectionWorkProjectRecordScore {
  collectionWorkProjectRecordId: number;
  userId: number;
  downloadTime: string;
  reviewTime: string;
  user: IUser;
  score: number;
}

export default class UseCollectionWorkProject {
  static save() {
    return usePost<ICollectionWorkProjectSaveParams, ICollectionWorkProject>('collectionWorkProject/save', {});
  }

  static list() {
    return useGet<ICollectionWorkProjectListParams, ICollectionWorkProject[]>('collectionWorkProject/list', {});
  }

  static listScore() {
    return useGet<ICollectionWorkProjectListScoreParams, ICollectionWorkProjectRecordScore[]>('collectionWorkProject/listScore', {});
  }

  static queryById() {
    return useGet<IQueryByIdParams, ICollectionWorkProject>('collectionWorkProject/queryById', {});
  }
}
